import { makeStyles } from "@mui/styles";
import React from "react";
// import SideMenus from "../components/SideMenus";
import PageMainContainer from "./PageMainContainer";

const useStyles = makeStyles({
  container: {
    minHeight: "100vh",
  },
});
function PageBodyContainer() {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {/* <SideMenus /> */}
      <PageMainContainer />
    </div>
  );
}

export default PageBodyContainer;
